import React from "react";
import clsx from "clsx";
import { lighten, makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Toolbar,
  Paper,
  CircularProgress,
} from "@material-ui/core";

const headRows = [
  {
    id: "finger",
    numeric: false,
    disablePadding: false,
    label: "Barmaq",
  },
  {
    id: "enrollDevice",
    numeric: false,
    disablePadding: false,
    label: "Enroll device",
  },
  {
    id: "hand",
    numeric: false,
    disablePadding: false,
    label: "Əl",
  },
  {
    id: "fingerPrintStatus",
    numeric: false,
    disablePadding: false,
    label: "Barmaq izi statusu",
  },
  {
    id: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "Yaradılma tarixi",
  },


];

function EnhancedTableHead(props) {
  return (
    <TableHead>
      <TableRow>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
          >
            <TableSortLabel
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}


const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    justifyContent: "flex-end",
  },
  highlight:
    theme.palette.type === "light"
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: "0 0 auto",
  },
  dense: {
    margin: theme.spacing(2),
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const {
    numSelected,

  } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >


    </Toolbar>
  );
};


const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  progresRoot: {
    width: "100%",
    padding: "32px 16px",
  },
  progress: {
    margin: "auto",
    display: "block",
    color: "#231B88",
  },
}));

export default function EnhancedTable({
  logRows,
  isLoading,
  isError,
  setText,
  setLogId,
  setShowCreate,
  setShowRemove,
  setShowRemoveSaps,

}) {


  const classes = useStyles();
  const permissionList = useSelector(state => state.auth.permissionList)

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {isLoading && (
          <div className={classes.progresRoot}>
            <CircularProgress className={classes.progress} />
          </div>
        )}
        <EnhancedTableToolbar
          setText={setText}
          setShowCreate={setShowCreate}
          setShowRemoveSaps={setShowRemoveSaps}
          permissionList={permissionList}
        />


        <div className={classes.tableWrapper}>
          { logRows && logRows.length ? (
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                rowCount={logRows.length}
              />
              <TableBody>
                {
                  logRows.map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow hover tabIndex={-1} key={index}>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.finger === 0 ? "Sol Çeçele barmaq" :
                            row.finger === 1 ? "Sol Adsız barmaq" :
                              row.finger === 2 ? "Sol Orta barmaq" :
                                row.finger === 3 ? "Sol Şəhadət barmağı" :
                                  row.finger === 4 ? "Sol Baş barmaq" :

                                    row.finger === 5 ? "Sağ Baş barmaq" :
                                      row.finger === 6 ? "Sağ Şəhadət barmağı" :
                                        row.finger === 7 ? "Sağ Orta barmaq" :
                                          row.finger === 8 ? "Sağ Adsız barmaq" :
                                            row.finger === 9 ? "Sağ Çeçele barmaq" :

                                              "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.enrollDevice ? row.enrollDevice : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {(row.hand && row.hand) === "LEFT_HAND" ? "Sol əl" : (row.hand && row.hand) === "RIGHT_HAND" && "Sağ əl"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.fingerPrintStatus === "REGISTERED_WITHOUT_DEVICE" ? "Qurğusuz qeydiyyatdan keçib" :
                            row.fingerPrintStatus === "REGISTERED" ? " Qeydiyyatdan keçib" : row.fingerPrintStatus === "UNREGISTERED" ?
                              " Qeydiyyatdan keçməyib" : "-"}
                        </TableCell>
                        <TableCell component="th" id={labelId} scope="row">
                          {row.createdAt ? row.createdAt.split("T")[0] : "-"}
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          ) :  logRows && !logRows.length && !isLoading && !isError ? (
            <div className="noInfo">
              <img
                src="/media/error/search.png"
                className="info-img"
                alt="information"
              />
              <h4>İnformasiya tapılmadı</h4>
            </div>
          ) : (
            !isLoading &&
            isError && (
              <div className="noInfo">
                <img
                  src="/media/error/connect.png"
                  className="info-img"
                  alt="connection"
                />
                <h4>Bağlantı yoxdur</h4>
              </div>
            )
          )}
        </div>

      </Paper>
    </div>
  );
}
